document.addEventListener('turbolinks:load', function () {
  $('#admin_resize_account_select, #admin_resize_img_size_select').on('change', function () {
    let account_id = $('#admin_resize_account_select option:selected').val();
    let img_size = $('#admin_resize_img_size_select option:selected').val();

    location.href = `/admin_resize_image_list?account_id=${account_id}&img_size=${img_size}`;
  });

  $('.admin_resize_img_submit').on('click', function () {
    let account_id = $('#admin_resize_account_select option:selected').val();
    let img_size = $('#admin_resize_img_size_select option:selected').val();

    let img_height = Number($(this).data('img_height'));
    let resize_val = Number($(this).data('resize'));
    let img_url = $(this).data('img_url');

    if (img_height < resize_val) {
      alert('現在の画像の高さより小さいサイズを選択してください。');
      return;
    }

    $.ajax({
      url: '/admin_resize_submit',
      type: 'POST',
      data: {
        account_id: account_id,
        img_size: img_size,
        resize_val: resize_val,
        img_url: img_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('#admin_resize_video_account_select').on('change', function () {
    let account_id = $('#admin_resize_video_account_select option:selected').val();
    let related_flag = $('#admin_resize_video_account_relation_flag option:selected').val();

    location.href = `/admin_resize_video_list?account_id=${account_id}&related_flag=${related_flag}`;
  });

  $('#admin_resize_video_account_relation_flag').on('change', function () {
    let account_id = $('#admin_resize_video_account_select option:selected').val();
    let related_flag = $('#admin_resize_video_account_relation_flag option:selected').val();

    location.href = `/admin_resize_video_list?account_id=${account_id}&related_flag=${related_flag}`;
  });

  // 新たに追加されるアップロード処理
  // $(document).on('click', '.upload_admin_resize_video', function() {
  $('.upload_admin_resize_video').on('click', function () {
    let index = $(this).data('index');
    let fileInput = $('#fileInput_' + index); // 不要な代入を削除
    let file = fileInput[0].files[0]; // 正しくファイルを取得

    if (!file) {
      alert('ファイルが選択されていません。');
      return;
    }

    let key = $(this).data('key'); // 正しくキーを取得

    let formData = new FormData();
    formData.append('video', file);
    formData.append('key', key);

    $.ajax({
      url: '/upload_admin_resize_video',
      type: 'POST',
      data: formData,
      processData: false, // jQueryがデータを処理しないように指定
      contentType: false, // contentTypeもfalseに設定
      success: function (data) {
        alert('アップロード成功!');
        location.reload();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        alert('アップロード失敗');
        location.reload();
      },
    });
  });

  $('.delete_admin_video').on('click', function () {
    let account_id = $('#admin_resize_video_account_select option:selected').val();
    
    let key = $(this).data('key'); // 正しくキーを取得
    let row = $(this).closest('tr'); // 削除する行を選択

    $.ajax({
      url: '/delete_admin_resize_video',
      type: 'POST',
      data: {
        account_id: account_id,
        key: key,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        row.fadeOut(400, function () {
          // フェードアウトアニメーションで行を削除
          $(this).remove(); // アニメーションが完了したらDOMから行を削除
        });
      } else {
        alert('削除に失敗しました。');
      }
    });
  });

  $('#create_admin_news_btn').on('click', function () {
    let title = $(".create_admin_news_title").val();
    let content = $(".create_admin_news_content").val();
    let flag = 0;

    if (!title || !content) {
      alert("タイトルまたは本文が空欄です。入力してください。");
      return;
    }

    if ($('.create_admin_news_flag:checked').length > 0) {
      flag = 1
    }

    $.ajax({
      url: '/create_admin_news',
      type: 'POST',
      data: {
        title: title,
        content: content,
        flag: flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.admin_news_edit').on('click', function () {
    let id = $(this).data("id");
    let title = $(this).data("title");
    let content = $(this).data("content");

    $(".admin_news_edit_id").val(id);
    $(".admin_news_edit_title").val(title);
    $(".admin_news_edit_content").val(content);

  });

  $('.admin_news_edit_submit_btn').on('click', function () {
    let id = $(".admin_news_edit_id").val();
    let title = $(".admin_news_edit_title").val();
    let content = $(".admin_news_edit_content").val();

    if (!id || !title || !content) {
      alert("タイトルまたは本文が空欄です。入力してください。");
      return;
    }

    $.ajax({
      url: '/edit_admin_news',
      type: 'POST',
      data: {
        title: title,
        content: content,
        id: id
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  $('.admin_news_display').on('click', function () {
    let id = $(this).data("id");
    let flag = $(this).data("flag");

    $.ajax({
      url: '/edit_admin_news_flag',
      type: 'POST',
      data: {
        id: id,
        flag: flag
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // topページ(ダッシュボード)
  $('.news_modal_click').on('click', function () {
    let title = $(this).data("title");
    let content = $(this).data("content");

    $(".news_modal_title").text(title);
    content = content.replace(/\n/g, '<br>');
    $(".news_modal_content").html(content);
  });
});
